import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { CameraPreview } from '@ionic-native/camera-preview';
import { HttpModule } from '@angular/http';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { NavigationBarColor } from 'ionic-plugin-navigation-bar-color';
import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { Base64 } from '@ionic-native/base64/ngx';

@NgModule({
  declarations: [
    MyApp,
    HomePage
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    NavigationBarColor,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    CameraPreview,
    ScreenOrientation,
    Base64
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts